<template>
    <section
        class="
            flex flex-col
            w-full
            lg:w-3/12 lg:min-h-screen
            border-l border-gray-200
            bg-white
            lg:h-screen
        "
    >
        <div class="w-auto">
            <div class="flex items-center flex-shrink-0 px-6 hidden">
                <img
                    class="h-16 w-auto"
                    src="https://timetospeak.nl/resources/images/logo/timetospeak-logo.png"
                    alt="TimeToSpeak"
                />
            </div>
            <div class="lg:h-screen flex-1 flex flex-col overflow-y-auto">
                <nav class="w-full">
                    <div
                        class="
                            h-full
                            flex flex-col
                            bg-white
                            shadow-xl
                            overflow-y-scroll
                        "
                    >
                        <header class="pt-6 px-6 hidden">
                            <div
                                class="
                                    flex
                                    items-start
                                    justify-between
                                    space-x-3
                                "
                            >
                                <h2
                                    class="
                                        text-lg
                                        leading-7
                                        font-medium
                                        text-gray-900
                                    "
                                >
                                    TTS
                                </h2>
                            </div>
                        </header>
                        <div class="border-b border-gray-200 pt-6">
                            <div class="px-6">
                                <div
                                    class="
                                        absolute
                                        right-0
                                        inline-block
                                        text-left
                                        mr-2
                                    "
                                    v-if="moderator_rights && tab == 'chat'"
                                >
                                    <div>
                                        <button
                                            class="
                                                flex
                                                cursor-pointer
                                                items-end
                                                text-gray-400
                                                hover:text-gray-600
                                                focus:outline-none
                                                focus:text-gray-600
                                            "
                                            aria-label="Options"
                                            id="options-menu"
                                            aria-haspopup="true"
                                            aria-expanded="true"
                                            @click="options = !options"
                                        >
                                            <svg
                                                class="h-5 w-5"
                                                fill="currentColor"
                                                viewBox="0 0 20 20"
                                            >
                                                <path
                                                    d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
                                                />
                                            </svg>
                                        </button>
                                    </div>
                                    <!-- <transition
                                        enter-active-class="transition ease-out duration-100"
                                        enter-class="transform opacity-0 scale-95"
                                        enter-to-class="transform opacity-100 scale-100"
                                        leave-active-class="transition ease-in duration-75"
                                        leave-class="transform opacity-100 scale-100"
                                        leave-to-class="transform opacity-0 scale-95"
                                    > -->
                                    <div
                                        class="
                                            origin-top-right
                                            absolute
                                            right-0
                                            mt-2
                                            w-56
                                            rounded-md
                                            shadow-2xl
                                            z-50
                                        "
                                        v-if="options"
                                    >
                                        <div
                                            class="
                                                rounded-md
                                                bg-white
                                                shadow-xs
                                            "
                                        >
                                            <section v-if="tab == 'chat'">
                                                <div
                                                    class="py-1"
                                                    role="menu"
                                                    aria-orientation="vertical"
                                                    aria-labelledby="options-menu"
                                                >
                                                    <a
                                                        @click="
                                                            clearChat();
                                                            options = false;
                                                        "
                                                        class="
                                                            cursor-pointer
                                                            block
                                                            px-4
                                                            py-2
                                                            text-sm
                                                            leading-5
                                                            text-gray-700
                                                            hover:bg-gray-100
                                                            hover:text-gray-900
                                                            focus:outline-none
                                                            focus:bg-gray-100
                                                            focus:text-gray-900
                                                        "
                                                        role="menuitem"
                                                        >{{
                                                            t(
                                                                "tts.sidebar.clear-chats"
                                                            )
                                                        }}</a
                                                    >
                                                    <a
                                                        @click="
                                                            stopChat();
                                                            options = false;
                                                        "
                                                        v-if="chatIs == 'open'"
                                                        class="
                                                            cursor-pointer
                                                            block
                                                            px-4
                                                            py-2
                                                            text-sm
                                                            leading-5
                                                            text-gray-700
                                                            hover:bg-gray-100
                                                            hover:text-gray-900
                                                            focus:outline-none
                                                            focus:bg-gray-100
                                                            focus:text-gray-900
                                                        "
                                                        role="menuitem"
                                                        >{{
                                                            t(
                                                                "tts.chats.stop-chat"
                                                            )
                                                        }}</a
                                                    >
                                                    <a
                                                        @click="
                                                            openChat();
                                                            options = false;
                                                        "
                                                        v-if="chatIs != 'open'"
                                                        class="
                                                            cursor-pointer
                                                            block
                                                            px-4
                                                            py-2
                                                            text-sm
                                                            leading-5
                                                            text-gray-700
                                                            hover:bg-gray-100
                                                            hover:text-gray-900
                                                            focus:outline-none
                                                            focus:bg-gray-100
                                                            focus:text-gray-900
                                                        "
                                                        role="menuitem"
                                                        >{{
                                                            t(
                                                                "tts.chats.open-chat"
                                                            )
                                                        }}</a
                                                    >
                                                    <a
                                                        @click="
                                                            showPinnedChats();
                                                            options = false;
                                                        "
                                                        v-if="
                                                            chatView != 'pinned'
                                                        "
                                                        class="
                                                            cursor-pointer
                                                            block
                                                            px-4
                                                            py-2
                                                            text-sm
                                                            leading-5
                                                            text-gray-700
                                                            hover:bg-gray-100
                                                            hover:text-gray-900
                                                            focus:outline-none
                                                            focus:bg-gray-100
                                                            focus:text-gray-900
                                                        "
                                                        role="menuitem"
                                                        >{{
                                                            t(
                                                                "tts.sidebar.show-pinned"
                                                            )
                                                        }}</a
                                                    >
                                                    <a
                                                        @click="
                                                            showNormalChats();
                                                            options = false;
                                                        "
                                                        v-if="
                                                            chatView == 'pinned'
                                                        "
                                                        class="
                                                            cursor-pointer
                                                            block
                                                            px-4
                                                            py-2
                                                            text-sm
                                                            leading-5
                                                            text-gray-700
                                                            hover:bg-gray-100
                                                            hover:text-gray-900
                                                            focus:outline-none
                                                            focus:bg-gray-100
                                                            focus:text-gray-900
                                                        "
                                                        role="menuitem"
                                                        >{{
                                                            t(
                                                                "tts.sidebar.show-chat"
                                                            )
                                                        }}</a
                                                    >
                                                    <!-- <a href="#" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">Support</a>
        <a href="#" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">Foobar</a> -->
                                                </div>
                                            </section>
                                            <div
                                                class="border-t border-gray-100"
                                            ></div>
                                        </div>
                                    </div>
                                    <!-- </transition> -->
                                </div>

                                <nav
                                    class="-mb-px flex space-x-4"
                                    @click="options = false"
                                >
                                    <a
                                        @click="switchTab('chat')"
                                        v-show="hasChatsTab"
                                        :class="{
                                            'whitespace-no-wrap pb-4 px-1 border-b-2 border-blue-500 font-medium text-sm leading-5 text-blue-600 focus:outline-none focus:text-blue-800 focus:border-blue-700  tabbar-active':
                                                tab == 'chat',
                                            'whitespace-no-wrap pb-4 px-1 border-b-2 border-transparent font-medium text-sm leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 tabbar':
                                                tab != 'chat',
                                        }"
                                        class="cursor-pointer"
                                        aria-current="page"
                                        >{{ t("tts.sidebar.chat") }}</a
                                    >

                                    <a
                                        v-if="
                                            tab_poll &&
                                            tab_poll != 'undefined' &&
                                            hasPollsTab
                                        "
                                        @click="switchTab('polls')"
                                        :class="{
                                            'whitespace-no-wrap pb-4 px-1 border-b-2 border-blue-500 font-medium text-sm leading-5 text-blue-600 focus:outline-none focus:text-blue-800 focus:border-blue-700 tabbar-active':
                                                tab == 'polls',
                                            'whitespace-no-wrap pb-4 px-1 border-b-2 border-transparent font-medium text-sm leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 tabbar':
                                                tab != 'polls',
                                        }"
                                        class="cursor-pointer"
                                        >{{ t("tts.sidebar.polls") }}</a
                                    >

                                    <a
                                        @click="switchTab('attendees')"
                                        v-show="hasAttendeesTab"
                                        :class="{
                                            'whitespace-no-wrap pb-4 px-1 border-b-2 border-blue-500 font-medium text-sm leading-5 text-blue-600 focus:outline-none focus:text-blue-800 focus:border-blue-700 tabbar-active':
                                                tab == 'attendees',
                                            'whitespace-no-wrap pb-4 px-1 border-b-2 border-transparent font-medium text-sm leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 tabbar':
                                                tab != 'attendees',
                                        }"
                                        class="cursor-pointer"
                                        >{{ t("tts.sidebar.attendees") }}</a
                                    >
                                    <a
                                        v-if="
                                            tab_document &&
                                            tab_document != 'undefined'
                                        "
                                        @click="switchTab('documents')"
                                        :class="{
                                            'whitespace-no-wrap pb-4 px-1 border-b-2 border-blue-500 font-medium text-sm leading-5 text-blue-600 focus:outline-none focus:text-blue-800 focus:border-blue-700 tabbar-active':
                                                tab == 'documents',
                                            'whitespace-no-wrap pb-4 px-1 border-b-2 border-transparent font-medium text-sm leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300 tabbar':
                                                tab != 'documents',
                                        }"
                                        class="cursor-pointer"
                                        >{{ t("tts.sidebar.info") }}</a
                                    >
                                </nav>
                            </div>
                        </div>

                        <chatbox
                            :can_moderate="moderator_rights"
                            :backstage="backstage"
                            :room="room"
                            :pusher="pusher"
                            :users="users"
                            :tenant="tenant"
                            v-show="tab == 'chat'"
                            :workshop="workshop"
                        ></chatbox>
                        <attendees
                            :users="users"
                            :pusher="pusher"
                            v-if="tab == 'attendees'"
                        ></attendees>
                        <polls
                            :can_initiate="moderator_rights"
                            :room="room"
                            :pusher="pusher"
                            :workshop="workshop"
                            v-if="tab == 'polls'"
                        ></polls>
                        <documents
                            :room="room"
                            :meeting="meeting"
                            v-if="tab == 'documents'"
                        ></documents>
                        <poll
                            v-if="poll"
                            :poll="poll"
                            @hide="poll = false"
                        ></poll>
                    </div>
                </nav>
            </div>
        </div>
    </section>
</template>

<script>
import Swal from "sweetalert2";
export default {
    mounted() {
        var host = window.location.host;
        var subdomain = host.split(".")[0];
        this.users = [];
        this.tenant = subdomain;
        this.getAuthenticatedUser();
        Eventing.listen("chatIsClosed", () => (this.chatIs = "closed"));
        Eventing.listen("revotePoll", (poll) => (this.poll = poll));

        Eventing.listen("hideTabChats", () => (this.hasChatsTab = false));
        Eventing.listen("noChat", () => (this.tab = ""));
        Eventing.listen("hideTabPolls", () => (this.hasPollsTab = false));
        Eventing.listen(
            "hideTabAttendees",
            () => (this.hasAttendeesTab = false)
        );
        Eventing.listen("addUser", (user) => this.addUser(user));

        this.switchTab('polls');
    },
    props: [
        "room",
        "tab_info",
        "workshop",
        "pusher",
        "tab_poll",
        "tab_document",
        "meeting",
        "backstage"
    ],
    created() {
        console.info("Room: " + this.room + " with " + this.pusher);
        let self = this;

        
        // if (this.pusher) {
        Echo.join("chats-" + this.pusher)
            .here((users) => {
                // try {
                //     this.users = users.filter(function (u) {
                //         return !u.tts;
                //     });
                // } catch (error) {
                //     this.users = users;
                // }
                this.users = users;
            })
            .joining((user) => {
                this.users.push(user);
                Eventing.fire("addUser", user);
            })
            .leaving((user) => {
                this.users = this.users.filter((u) => u.id != user.id);
            });

        Echo.private("polls." + this.pusher)
            .listen(".new-poll", (e) => {
                if (self.current_user.voting_weight > 0) {
                    this.poll = e.poll;
                }
            })
            .listen(".stop-poll", (e) => {
                this.poll = null;
            });
        // } else {
        //     // alert("NO PUSHER: " + this.pusher);
        // }
    },
    beforeUnmount: function () {
        // alert('DOEI')
        this.users = this.users.filter((u) => u.id != this.current_user.id);
    },
    data() {
        return {
            hasChatsTab: true,
            hasPollsTab: true,
            hasAttendeesTab: true,
            tenant: null,
            options: false,
            chatView: "normal",
            chatIs: "open",
            tab: "chat",
            poll: null,
            users: [],
            moderator_rights: false,
            current_user: {
                id: null,
                voting_weight: 0,
                is_moderator: false,
                is_global_moderator: false,
            },
        };
    },
    methods: {
        addUser(user) {
            let self = this;
            var obj = this.users;
            var found = Object.keys(obj).filter(function (key) {
                return obj[key].id == self.current_user.id;
            });
            if (!found) {
                self.users.push(user);
            }
        },
        showPinnedChats() {
            Eventing.fire("showPinnedChats");
            this.chatView = "pinned";
        },
        showNormalChats() {
            Eventing.fire("showNormalChats");
            this.chatView = "normal";
        },
        clearChat() {
            let self = this;
            self.options = false;
            Swal.fire({
                title: self.t("tts.sidebar.clear-chat-title"),
                text: self.t("tts.sidebar.clear-chat-text"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#de3618",
                cancelButtonColor: "#333",
                confirmButtonText: self.t("tts.yes"),
                cancelButtonText: self.t("tts.cancel"),
            }).then((result) => {
                if (result.value) {
                    axios
                        .post("/api/chats", {
                            cleanup: true,
                            room: self.room,
                            workshop: self.workshop,
                        })
                        .then((response) => {})
                        .catch((error) => {});
                }
            });
        },
        stopChat() {
            let self = this;
            self.options = false;
            Swal.fire({
                title: self.t("tts.chats.stop-chat-title"),
                text: self.t("tts.chats.stop-chat-text"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#de3618",
                cancelButtonColor: "#333",
                confirmButtonText: self.t("tts.yes"),
                cancelButtonText: self.t("tts.cancel"),
            }).then((result) => {
                if (result.value) {
                    axios
                        .post("/api/chats", {
                            chatbox: "close",
                            room: self.room,
                            workshop: self.workshop,
                        })
                        .then((response) => {
                            self.chatIs = "closed";
                        })
                        .catch((error) => {});
                }
            });
        },
        openChat() {
            let self = this;
            self.options = false;
            Swal.fire({
                title: self.t("tts.chats.open-chat-title"),
                text: self.t("tts.chats.open-chat-text"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#de3618",
                cancelButtonColor: "#333",
                confirmButtonText: self.t("tts.yes"),
                cancelButtonText: self.t("tts.cancel"),
            }).then((result) => {
                if (result.value) {
                    axios
                        .post("/api/chats", {
                            chatbox: "open",
                            room: self.room,
                            workshop: self.workshop,
                        })
                        .then((response) => {
                            self.chatIs = "open";
                        })
                        .catch((error) => {});
                }
            });
        },
        switchTab(tab) {
            var self = this;
            self.tab = tab;
        },
        getAuthenticatedUser() {
            this.current_user = {
                id: document.head.querySelector('meta[name="id"]').content,
                voting_weight: parseInt(
                    document.head.querySelector('meta[name="voting_weight"]')
                        .content
                ),
                is_moderator: document.head.querySelector(
                    'meta[name="is_moderator"]'
                ).content,
                is_global_moderator: false,
            };

            if (
                document.head.querySelector('meta[name="is_moderator"]')
                    .content == "true"
            ) {
                this.moderator_rights = true;
                this.current_user.is_global_moderator = true;
            }
        },
    },
};
</script>
